import { DropdownOption, FieldType } from './forms-types';

export const getUniqueSlug = (field: FieldType) => {
    if (field.extraSettings?.name?.value) {
        return field.extraSettings.name.value;
    }

    return field.slug;
    // We had this previously, but changing to use the name given in Gutenberg so we can pass the data to salesforce
    // with the correct value, matching what salesforce expects.
    // Not sure if this can cause any issues, so i'm keeping the below as a reference.
    // return `${field.slug}-${field.instance}`;
};

// Parse options from newline-separated string with optional pipe-separated label/value.
// Format: "value|label" per line, or just "value" (label auto-capitalized).
export const parseFieldOptions = (optionsString: string): DropdownOption[] => {
    return optionsString
        .split('\n')
        .map((v: string) => v.trim())
        .map((v: string) => {
            if (v.includes('|')) {
                const [value, label] = v.split('|').map(s => s.trim());
                return { value, text: label || value };
            }
            return { value: v, text: v.charAt(0).toUpperCase() + v.slice(1) };
        })
        .filter((option: DropdownOption) => option.value);
};

export const isHcpOnlyField = (field: FieldType): boolean => {
    return field.extraSettings?.hcpOnly?.value === 'true';
};

export const isPatientOnlyField = (field: FieldType): boolean => {
    return field.extraSettings?.patientOnly?.value === 'true';
};

export const isFieldVisibleForUserType = (field: FieldType, userType: string): boolean => {
    // hcpOnly groups HCP + Other; patientOnly groups Patient + Relative.
    if (isHcpOnlyField(field)) return userType === 'HCP' || userType === 'Other';
    if (isPatientOnlyField(field)) return userType === 'Patient' || userType === 'Relative';
    return true;
};

export const hasUserTypeRestriction = (field: FieldType): boolean => {
    return isHcpOnlyField(field) || isPatientOnlyField(field);
};
